// =============================================================================
// Origin UI — src/main.tsx
// Application entry point. Mounts the React app to the DOM.
// Imports global styles (OQT Origin UI Style Guide).
// =============================================================================

import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import './styles/global.css';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>
);
